import { makeStyles } from '@mui/styles';

export const useStyle = makeStyles((theme) => ({
  paperTemplate: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(2),
    gap: theme.spacing(2),
  }
}));
